// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brevo-config-panel {
  margin-top: 1.5rem;
}
.brevo-config-panel .panel-title {
  font-weight: 600;
}
.brevo-config-panel .panel-title i {
  margin-right: 0.5rem;
}

.key-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.key-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  font-weight: 500;
}
.key-status.status-configured {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.key-status.status-missing {
  background-color: #fff3e0;
  color: #e65100;
}

.p-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.p-field label {
  font-weight: 600;
}
.p-field .full-width {
  width: 100%;
  max-width: 600px;
}

.form-actions {
  display: flex;
  gap: 1rem;
}

.loading-state {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-color-secondary);
}

.empty-state {
  margin-top: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-color-secondary);
  font-style: italic;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/settings/brevo-config/brevo-config.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,gBAAA;AACR;AAAQ;EAAI,oBAAA;AAGZ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;AAAI;EACI,yBAAA;EACA,cAAA;AAER;AACI;EACI,yBAAA;EACA,cAAA;AACR;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAAJ;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,WAAA;EACA,gBAAA;AADR;;AAKA;EACI,aAAA;EACA,SAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kCAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kCAAA;EACA,kBAAA;AAFJ;AACA,g4EAAg4E","sourcesContent":[".brevo-config-panel {\n    margin-top: 1.5rem;\n\n    .panel-title {\n        font-weight: 600;\n        i { margin-right: 0.5rem; }\n    }\n}\n\n.key-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n}\n\n.key-status {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    border-radius: 4px;\n    font-weight: 500;\n\n    &.status-configured {\n        background-color: #e8f5e9;\n        color: #2e7d32;\n    }\n\n    &.status-missing {\n        background-color: #fff3e0;\n        color: #e65100;\n    }\n}\n\n.p-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n\n    label {\n        font-weight: 600;\n    }\n\n    .full-width {\n        width: 100%;\n        max-width: 600px;\n    }\n}\n\n.form-actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.loading-state {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: var(--text-color-secondary);\n}\n\n.empty-state {\n    margin-top: 2rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: var(--text-color-secondary);\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
